export { isMonarchMultipleAccountsEnabled } from './flights';
export { isStrictSourceIdEnabled } from './isStrictSourceIdEnabled';
export {
    getInMemorySourceIdForMailboxInfo,
    getInMemoryMailboxInfoBySourceId,
} from './inMemorySourceList';
export { getLegacySourceIdListDetails, setLegacyPluggableHost } from './legacyPluggableHost';
export type { LegacyHostAccountInformation } from './legacyPluggableHost';
export {
    getLegacyMailboxBySourceId,
    getLegacyPropertiesForSourceId,
    getLegacyPropertyForSourceId,
    getLegacySourceIdByProperty,
    getLegacySourceIdList,
} from './legacySourceList';
export {
    getSourceIdForUserIdentity,
    updatePluggableHost,
    addM365Account,
    addOutlookDotComAccount,
    removeAccount,
} from './pluggableHost';
export { getSelectedSourceId, setSelectedSourceId } from './selectedAccount';
export { addHostAccount, getMailboxBySourceId, getMailboxTypeBySourceId } from './sourceList';
export { CreateAccountErrors, RemoveAccountErrors, SourceType, SourceAuthType } from './types';
export type {
    CreateAccountResult,
    HostSourceInformation,
    RemoveAccountResult,
    SourceIdAndDisplayName,
} from './types';
export type { PluggableHostAccountSource } from './pluggableHost';
